import { IDropdownStyles, IStyle } from '@fluentui/react';
import { FontWeights, IH2OTheme } from '@h2oai/ui-kit';

export interface IPodUsageContentStyles {
  root?: IStyle;
  chartContainer?: IStyle;
  paramLabel?: IStyle;
  inlineCode?: IStyle;
  timePeriodContainer?: IStyle;
  timePeriod?: IStyle;
}

export const podUsageContentStylesDefault = (theme: IH2OTheme): Partial<IPodUsageContentStyles> => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  chartContainer: {
    width: '100%',
  },
  paramLabel: {
    margin: 0,
    fontWeight: FontWeights.fw600,
    color: theme.palette?.green800,
  },
  inlineCode: {
    fontFamily: "'Consolas', 'Monaco', 'Courier New', monospace",
    fontSize: '12px',
    backgroundColor: 'var(--h2o-gray100, #F3F4F6)',
    color: 'var(--h2o-gray700, #374151)',
    padding: '2px 6px',
    borderRadius: '4px',
    border: '1px solid var(--h2o-gray200, #E5E7EB)',
    fontWeight: '500',
  },
  timePeriodContainer: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
  },
  timePeriod: {
    display: 'flex',
    gap: 4,
  },
});

export const granularityDropdownStyles = (): Partial<IDropdownStyles> => ({
  label: {
    paddingTop: 0,
  },
});
